<template>
  <div class="box8">
    <div class="subject-content">
      <pageTitle
        title="课程满足多群体需求<br/>职业发展路径明确"
        text="拒绝盲目摸索，帮你构建前端晋级之路"
        titleColor="#FFFFFF"
        titColor="#FFFFFF"
      />
      <div class="topImg"></div>
    </div>
    <div class="wrap">
      <div class="xian"></div>
      <div class="title">适学人群</div>
      <div class="content">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="name">
            <img :src="item.img" alt="" />
            <div class="tit">{{ item.tit }}</div>
          </div>
          <div class="desc" v-html="item.txt"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/web/box8/1.png"),
          tit: "刚毕业迷茫期",
          txt: "没有工作经验<br />期待学习有前景的技术",
        },
        {
          img: require("../../../assets/coursePage/web/box8/2.png"),
          tit: "零基础想转行",
          txt: "行业没前途<br />期待短期内转行IT",
        },
        {
          img: require("../../../assets/coursePage/web/box8/3.png"),
          tit: "想晋升加薪",
          txt: "具备前端基础<br />面临职场瓶颈期待提升",
        },

        {
          img: require("../../../assets/coursePage/web/box8/4.png"),
          tit: "前端爱好者",
          txt: "薪资不满意<br />期待进军前端热门领域",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box8 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  padding-bottom: 88px;
  margin-top: 0px;
  .pagetitle {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    text-align: center;
  }
  .subject-content {
    padding-top: 80px;
    background: url("../../../assets/coursePage/web/box8/bgc.png") no-repeat;
    width: 100%;
    height: 1200px;
    .topImg {
      width: 612px;
      height: 700px;
      margin: 48px auto 80px;
      background: url("../../../assets/coursePage/web/box8/topimg.png")
        no-repeat;
      background-size: cover;
    }
  }
  .wrap {
    width: 686px;
    height: 500px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.12);
    border-radius: 20px;
    border: 1px solid #ffffff;
    position: relative;
    box-sizing: border-box;
    margin: -205px auto 0;
    .xian {
      background: url("../../../assets/coursePage/web/box8/centerbgc.png")
        no-repeat;
      width: 622px;
      background-size: cover;
      height: 344px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 108px;
    }
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      margin: 32px 0 32px;
      text-align: center;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      height: 344px;
      padding: 0 52px 0px;

      box-sizing: border-box;
      align-content: space-between;
      .item {
        box-sizing: border-box;
        display: flex;
        justify-content: center;

        flex-wrap: wrap;
        width: 240px;
        .name {
          display: flex;
          align-items: center;
          img {
            margin-right: 6px;
            width: 32px;
            height: 32px;
          }
          .tit {
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #00b589;
            line-height: 44px;
          }
        }
        .desc {
          margin-top: 16px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #1d2129;
          line-height: 40px;
          text-align: center;
        }
      }
    }
  }
}
</style>
